import { useRef as t } from "react";
import { useWindowEvent as a } from './use-window-event.js';

var s = function (r) {
  return r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r;
}(s || {});

function n() {
  var e = t(0);
  return a("keydown", function (o) {
    o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
  }, !0), e;
}

export { s as Direction, n as useTabDirection };